// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found[data-v-0fee9735] {\n  margin-top: 30px;\n  font-size: 36px;\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
